import React, { useEffect, useState } from "react";
import PropTypes, { func } from "prop-types";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import {
	Button,
	Card,
	CardText,
	CardTitle,
	Col,
	Form,
	FormFeedback,
	FormGroup,
	Input,
	Label,
	Nav,
	NavItem,
	NavLink,
	Row,
	TabContent,
	TabPane,
	Table,
} from "reactstrap";
import companyService from "../../../../services/CompanyService";
import companyPhoneService from "../../../../services/CompanyPhoneService";
import { getCep, getCnpj } from "../../../../services/ConsultCnpjCepService";
import { useFormik } from "formik";
import withRouter from "../../../../components/Common/withRouter";
import { useNavigate } from "react-router-dom";
import setorService from "../../../../services/SetorService";
import Select from "react-select";
import ModalSetor from "./modalSetor";
import { FloppyDisk, Phone, Plus, Trash } from "@phosphor-icons/react";
import { IconButton, Tooltip } from "@mui/material";

const FormEmpresa = (props) => {
	const [data, setData] = useState(null);
	const [consultCnpj, setConsultCNPJ] = useState();
	const [consultCep, setConsultCEP] = useState("");
	const [funcoes, setFuncoes] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [phones, setPhones] = useState([]);
	const [guidelines, setGuidelines] = useState([]);
	const [state, setState] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const [activeTab2, setActiveTab2] = useState("1");

	document.title = "Senda | Empresas";

	const params = props.router.params;
	const id = params?.id;

	const navigate = useNavigate();

	const validation = useFormik({
		enableReinitialize: true,

		initialValues: {
			name: data?.name || "",
			cnpj: data?.cnpj || "",
			address: data?.address || "",
			cep: data?.cep || "",
			district: data?.district || "",
			number: data?.number || "",
			city: data?.city || "",
			complement: data?.complement || "",
			state: data?.state || "",
			sector_id: data?.sector_id || "",
			active: data?.active || 1,
			state_registration: data?.state_registration || "",
		},

		validate: (values) => {
			const errors = {};

			if (!values.name && !consultCnpj) {
				errors.name = "Campo obrigatório";
			}
			if (!values.cnpj) {
				errors.cnpj = "Campo obrigatório";
			}
			if (!values.cep) {
				errors.cep = "Campo obrigatório";
			}
			if (!values.city && !consultCep) {
				errors.city = "Campo obrigatório";
			}
			if (!values.district && !consultCep) {
				errors.district = "Campo obrigatório";
			}
			if (!values.state && !consultCep) {
				errors.state = "Campo obrigatório";
			}
			if (!values.number) {
				errors.number = "Campo obrigatório";
			}
			if (!values.address && !consultCep) {
				errors.address = "Campo obrigatório";
			}
			if (!values.sector_id) {
				errors.sector_id = "Campo obrigatório";
			}

			return errors;
		},

		onSubmit: async (values) => {
			const allValues = values;
			allValues.address = values.address || consultCep.street;
			allValues.city = values.city || consultCep.city;
			allValues.name = values.name || consultCnpj;
			allValues.district = values.district || consultCep.district;
			allValues.state = values.state || consultCep.stateShortname;
			allValues.state_registration = !values.state_registration
				? "Isento"
				: values.state_registration;
			allValues.active = values.active ? 1 : 0;

			const finalPhones = phones.filter((f) => f !== "");
			const finalGuidelines = guidelines.filter((f) => {
				return f.name !== "" && f.description !== "" && f !== "";
			});

			const data = {
				company: allValues,
				phones: finalPhones,
				guidelines: finalGuidelines,
			};

			setIsLoading(true);
			if (id) {
				await companyService.put(id, data);
			} else {
				await companyService.post(data);
			}
			setIsLoading(false);
			navigate("/empresas");
		},
	});

	const customStyles = {
		option: (provided, state) => ({
			...provided,
			color: state.isSelected ? "blue" : "black",
			backgroundColor: "white",
			"&:hover": {
				backgroundColor: "#556ee6",
			},
		}),
	};

	const getItems = async () => {
		try {
			const response = await companyService.getById(id);
			setData(response);
			const guidelines = response.guidelines.map((item) => {
				return {
					name: item.name,
					description: item.description,
					show_dashboard: item.hasOwnProperty("show_dashboard")
						? item.show_dashboard
						: true,
				};
			});
			setGuidelines(guidelines);
		} catch (error) {
			console.log(error);
		}
	};

	const getCnpjApi = async (value) => {
		const cnpjNumber = value?.replace(/\D/g, "");
		if (cnpjNumber) {
			const response = await getCnpj(cnpjNumber);
			setConsultCNPJ(response.razao_social);
		}
	};

	const getCepApi = async (value) => {
		const cepNumber = value?.replace(/\D/g, "");
		if (cepNumber) {
			const response = await getCep(cepNumber);
			setConsultCEP(response.result);
		}
	};

	const getPhones = async () => {
		if (id) {
			try {
				const response = await companyPhoneService.getById(id);
				const numbers = response.map((res) => res.number);
				setPhones(numbers);
			} catch (error) {
				console.log(error);
			}
		} else {
			setPhones([""]);
		}
	};

	const cnpjMask = (value) => {
		return value
			.replace(/\D+/g, "")
			.replace(/(\d{2})(\d)/, "$1.$2")
			.replace(/(\d{3})(\d)/, "$1.$2")
			.replace(/(\d{3})(\d)/, "$1/$2")
			.replace(/(\d{4})(\d)/, "$1-$2")
			.replace(/(-\d{2})\d+?$/, "$1");
	};

	const cepMask = (value) => {
		return value
			.replace(/\D/g, "")
			.replace(/(\d{2})(\d)/, "$1.$2")
			.replace(/(\d{3})(\d)/, "$1-$2")
			.replace(/(-\d{3})\d+?$/, "$1");
	};

	const phoneMask = (value, index) => {
		if (!value) return "";
		if (value < 15) {
			return value
				.replace(/\D+/g, "")
				.replace(/(\d{2})(\d)/, "($1) $2")
				.replace(/(\d)(\d{4})$/, "$1-$2");
		} else {
			return value
				.replace(/\D+/g, "")
				.replace(/(\d{2})(\d)/, "($1) $2")
				.replace(/(\d)(\d{4})$/, "$1-$2");
		}
	};

	const changedCnpj = (value) => {
		const cnpjValueNumbers = value.target.value;
		if (cnpjValueNumbers.length === 18) {
			getCnpjApi(cnpjValueNumbers);
		} else {
			setConsultCNPJ("");
		}
	};

	const changedCep = (value) => {
		const cepValueNumbers = value.target.value;
		if (cepValueNumbers.length === 10) {
			getCepApi(cepValueNumbers);
		} else {
			setConsultCEP("");
			validation.setFieldValue("cep", cepValueNumbers);
			validation.setFieldValue("district", "");
			validation.setFieldValue("address", "");
			validation.setFieldValue("city", "");
			validation.setFieldValue("state", "");
		}
	};

	async function getSetores() {
		try {
			const response = await setorService.get();
			const funcoes = response.map((item) => {
				return {
					value: item.id,
					label: item.name,
				};
			});
			setFuncoes(funcoes);
		} catch (error) {
			console.log(error);
		}
	}

	const showModalNewSetor = () => {
		setShowModal(true);
	};

	function onCloseModal() {
		setShowModal(false);
	}

	const addNewPhone = () => {
		const newPhone = [...phones];
		newPhone.push("");
		setPhones(newPhone);
	};

	const removePhone = (event) => {
		let tel = [...phones];
		if (tel.length > 1) {
			const newPhones = tel.filter((t, index) => index !== event);
			setPhones(newPhones);
		}
	};

	const changePhones = (event, index) => {
		let tel = [...phones];
		const newPhones = tel.map((t, i) =>
			i === index ? phoneMask(event.target.value) : phoneMask(t),
		);
		setPhones(newPhones);
	};

	const addNewGuideline = () => {
		const newGuideline = [...guidelines];
		newGuideline.push({ name: "", description: "", show_dashboard: true }); // Default to true
		setGuidelines(newGuideline);
	};

	const removeGuideline = (indexToRemove) => {
		let newGuidelines = guidelines.filter(
			(_, index) => index !== indexToRemove,
		);
		setGuidelines(newGuidelines);
	};

	const changeGuideline = (event, index, field) => {
		let guideline = [...guidelines];
		const newGuidelines = guideline.map((t, i) =>
			i === index
				? { ...guideline[index], [field]: event.target.value }
				: guideline[i],
		);
		setGuidelines(newGuidelines);
	};

	const toggleGuidelineSwitch = (index) => {
		let guideline = [...guidelines];
		const newGuidelines = guideline.map((t, i) =>
			i === index
				? {
						...guideline[index],
						show_dashboard: !guideline[index].show_dashboard,
				  }
				: guideline[i],
		);
		setGuidelines(newGuidelines);
	};

	const toggleTab = (tab) => {
		if (activeTab2 !== tab) setActiveTab2(tab);
	};

	useEffect(() => {
		getSetores();
	}, [showModal]);

	useEffect(() => {
		if (id) {
			getItems();
		}
		getPhones();
	}, []);

	return (
		<div className="page-content">
			<Breadcrumbs
				title="Empresas"
				breadcrumbItem="Cadastro de Empresa"
				backLink="/empresas"
			/>

			<div
				className="container-fluid"
				style={{
					backgroundColor: "white",
					padding: 20,
					borderRadius: 10,
					marginTop: 25,
				}}
			>
				<Form
					className="needs-validation"
					onSubmit={(e) => {
						e.preventDefault();
						validation.handleSubmit();
						return false;
					}}
				>
					<Nav tabs>
						<NavItem>
							<NavLink
								className={activeTab2 === "1" ? "active" : ""}
								onClick={() => toggleTab("1")}
							>
								Dados gerais
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink
								className={activeTab2 === "2" ? "active" : ""}
								onClick={() => toggleTab("2")}
							>
								Macro Diretrizes
							</NavLink>
						</NavItem>
					</Nav>
					<TabContent activeTab={activeTab2}>
						<TabPane tabId="1">
							<Row style={{ marginTop: 10 }}>
								<Col md="4">
									<FormGroup className="mb-3">
										<Label htmlFor="validationCustom01">
											CNPJ{" "}
											<span style={{ color: "red" }}>
												*
											</span>
										</Label>
										<Input
											name="cnpj"
											placeholder="CNPJ"
											type="text"
											className="form-control"
											id="validationCustom01"
											onChange={(value) => {
												validation.handleChange(value);
												changedCnpj(value);
											}}
											onBlur={validation.handleBlur}
											value={
												cnpjMask(
													validation.values.cnpj,
												) || ""
											}
											disabled={data?.cnpj ? true : false}
											invalid={
												validation.touched.cnpj &&
												validation.errors.cnpj
													? true
													: false
											}
										/>
									</FormGroup>
								</Col>
								<Col md="4">
									<FormGroup className="mb-3">
										<Label htmlFor="validationCustom01">
											Nome da Empresa{" "}
											<span style={{ color: "red" }}>
												*
											</span>
										</Label>
										<Input
											name="name"
											placeholder="Nome"
											type="text"
											id="validationCustom01"
											onChange={validation.handleChange}
											value={
												validation.values.name ||
												consultCnpj?.substring(0, 60) ||
												""
											}
											invalid={
												validation.touched.name &&
												validation.errors.name &&
												!consultCnpj
													? true
													: false
											}
											maxLength={60}
										/>
									</FormGroup>
								</Col>
								<Col md="4">
									<FormGroup className="mb-3">
										<Label htmlFor="validationCustom01">
											Setor{" "}
											<span style={{ color: "red" }}>
												*
											</span>
										</Label>
										<div className="d-flex align-items-center">
											<Select
												name="sector_id"
												placeholder="Selecione"
												type="text"
												styles={customStyles}
												id="validationCustom01"
												onChange={(selectedOption) => {
													const selectedValue =
														selectedOption
															? selectedOption.value
															: "";
													validation.setFieldValue(
														"sector_id",
														selectedValue,
													);
												}}
												onBlur={validation.handleBlur}
												value={funcoes.find(
													(option) =>
														option.value ===
														validation.values
															.sector_id,
												)}
												options={funcoes}
												className={`col-10 ${
													validation.touched
														.sector_id &&
													validation.errors.sector_id
														? "is-invalid"
														: ""
												}`}
											/>
											<Button
												style={{
													background: "none",
													cursor: "pointer",
													color: "black",
													marginLeft: 15,
												}}
												onClick={() =>
													showModalNewSetor()
												}
												className="col-1.5"
											>
												<Plus size={16} />
											</Button>
										</div>
										{validation.touched.sector_id &&
											validation.errors.sector_id && (
												<FormFeedback
													type="invalid"
													className="d-block"
												>
													{
														validation.errors
															.sector_id
													}
												</FormFeedback>
											)}
									</FormGroup>
								</Col>
							</Row>
							<Row>
								<Col md="24">
									<Card
										style={{
											display: "flex",
											alignContent: "center",
											justifyContent: "center",
											margin: "auto",
											border: "1px solid #e8e8e8",
											borderRadius: "10px",
											padding: "10px",
											marginTop: "10px",
										}}
									>
										<CardTitle className="d-flex justify-content-between align-items-center">
											<span>Telefones</span>
											<Button
												style={{
													background: "none",
													padding: 10,
													cursor: "pointer",
													color: "black",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													gap: 2,
												}}
												onClick={addNewPhone}
											>
												<Phone size={16} /> Adicionar
												Telefone
											</Button>
										</CardTitle>
										<CardText>
											<Table striped bordered hover>
												<thead>
													<tr>
														<th>Telefone</th>
														<th>Ações</th>
													</tr>
												</thead>
												<tbody>
													{phones.map(
														(phone, index) => {
															return (
																<tr key={index}>
																	<td>
																		<Input
																			name="phone"
																			placeholder="Telefone"
																			type="text"
																			className="form-control"
																			id="validationCustom01"
																			onChange={(
																				event,
																			) =>
																				changePhones(
																					event,
																					index,
																				)
																			}
																			value={
																				phone
																			}
																			maxLength={
																				15
																			}
																		/>
																	</td>
																	<td>
																		<Button
																			style={{
																				background:
																					"none",
																				cursor: "pointer",
																				color: "black",
																				display:
																					"flex",
																				alignItems:
																					"center",
																				justifyContent:
																					"center",
																				gap: 2,
																			}}
																			onClick={() =>
																				removePhone(
																					index,
																				)
																			}
																		>
																			<Trash
																				size={
																					16
																				}
																			/>{" "}
																			Excluir
																		</Button>
																	</td>
																</tr>
															);
														},
													)}
												</tbody>
											</Table>
										</CardText>
									</Card>
								</Col>
							</Row>

							<Row></Row>
							<Row style={{ marginTop: 20 }}>
								<Col md="4">
									<FormGroup className="mb-3">
										<Label htmlFor="validationCustom01">
											CEP{" "}
											<span style={{ color: "red" }}>
												*
											</span>
										</Label>
										<Input
											name="cep"
											placeholder="CEP"
											type="text"
											className="form-control"
											id="validationCustom01"
											onChange={(value) => {
												validation.handleChange(value);
												changedCep(value);
											}}
											onBlur={validation.handleBlur}
											value={
												cepMask(
													validation.values.cep,
												) ||
												consultCep?.number ||
												""
											}
											maxLength={10}
											invalid={
												validation.touched.cep &&
												validation.errors.cep
													? true
													: false
											}
										/>
									</FormGroup>
								</Col>
								<Col md="4">
									<FormGroup className="mb-3">
										<Label htmlFor="validationCustom01">
											Cidade{" "}
											<span style={{ color: "red" }}>
												*
											</span>
										</Label>
										<Input
											name="city"
											placeholder="Cidade"
											type="text"
											className="form-control"
											id="validationCustom01"
											onChange={validation.handleChange}
											onBlur={validation.handleBlur}
											value={
												validation.values.city ||
												consultCep?.city ||
												""
											}
											invalid={
												validation.touched.city &&
												validation.errors.city &&
												!consultCep?.city
													? true
													: false
											}
										/>
									</FormGroup>
								</Col>
								<Col md="4">
									<FormGroup className="mb-3">
										<Label htmlFor="validationCustom01">
											Estado (UF){" "}
											<span style={{ color: "red" }}>
												*
											</span>
										</Label>
										<Input
											name="state"
											placeholder="UF"
											type="text"
											className="form-control"
											id="validationCustom01"
											onChange={validation.handleChange}
											onBlur={validation.handleBlur}
											value={
												validation.values.state ||
												consultCep?.stateShortname ||
												""
											}
											maxLength={2}
											invalid={
												validation.touched.state &&
												validation.errors.state &&
												!consultCep?.stateShortname
													? true
													: false
											}
										/>
									</FormGroup>
								</Col>
							</Row>

							<Row>
								<Col md="4">
									<FormGroup className="mb-3">
										<Label htmlFor="validationCustom01">
											Bairro{" "}
											<span style={{ color: "red" }}>
												*
											</span>
										</Label>
										<Input
											name="district"
											placeholder="Bairro"
											type="text"
											className="form-control"
											id="validationCustom01"
											onChange={validation.handleChange}
											onBlur={validation.handleBlur}
											value={
												validation.values.district ||
												consultCep?.district ||
												""
											}
											invalid={
												validation.touched.district &&
												validation.errors.district &&
												!consultCep?.district
													? true
													: false
											}
										/>
									</FormGroup>
								</Col>
								<Col md="4">
									<FormGroup className="mb-3">
										<Label htmlFor="validationCustom01">
											Logradouro{" "}
											<span style={{ color: "red" }}>
												*
											</span>
										</Label>
										<Input
											name="address"
											placeholder="Logradouro"
											type="text"
											className="form-control"
											id="validationCustom01"
											onChange={validation.handleChange}
											onBlur={validation.handleBlur}
											value={
												validation.values.address ||
												consultCep?.street ||
												""
											}
											invalid={
												validation.touched.address &&
												validation.errors.address &&
												!consultCep?.street
													? true
													: false
											}
										/>
									</FormGroup>
								</Col>
								<Col md="4">
									<FormGroup className="mb-3">
										<Label htmlFor="validationCustom01">
											Número{" "}
											<span style={{ color: "red" }}>
												*
											</span>
										</Label>
										<Input
											name="number"
											placeholder="Número"
											type="text"
											className="form-control"
											id="validationCustom01"
											onChange={validation.handleChange}
											onBlur={validation.handleBlur}
											value={
												validation.values.number || ""
											}
											invalid={
												validation.touched.number &&
												validation.errors.number
													? true
													: false
											}
										/>
									</FormGroup>
								</Col>
							</Row>

							<Row>
								<Col md="6">
									<FormGroup className="mb-3">
										<Label htmlFor="validationCustom01">
											Inscrição Estadual
										</Label>
										<Input
											name="state_registration"
											placeholder="Numero Inscrição Estadual"
											type="text"
											className="form-control"
											id="validationCustom01"
											onChange={validation.handleChange}
											onBlur={validation.handleBlur}
											value={
												validation.values
													.state_registration || ""
											}
										/>
									</FormGroup>
								</Col>
								<Col md="6">
									<FormGroup className="mb-3">
										<Label htmlFor="validationCustom01">
											Complemento
										</Label>
										<Input
											name="complement"
											placeholder="Complemento"
											type="text"
											className="form-control"
											id="validationCustom01"
											onChange={validation.handleChange}
											onBlur={validation.handleBlur}
											value={
												validation.values.complement ||
												""
											}
										/>
									</FormGroup>
								</Col>
							</Row>

							<Row>
								<Col md="1">
									<FormGroup switch>
										<Input
											type="switch"
											checked={state}
											onClick={() => {
												setState(!state);
												validation.setFieldValue(
													"active",
													!validation.values.active,
												);
											}}
											name="active"
										/>
										<Label check>Ativa!</Label>
									</FormGroup>
								</Col>
							</Row>
						</TabPane>

						<TabPane tabId="2">
							<Row style={{ marginTop: 10 }}>
								<Col md="24">
									<Card
										style={{
											display: "flex",
											alignContent: "center",
											justifyContent: "center",
											margin: "auto",
											border: "1px solid #e8e8e8",
											borderRadius: "10px",
											padding: "10px",
											marginTop: "10px",
										}}
									>
										<CardTitle className="d-flex justify-content-between align-items-center">
											<span>Diretrizes</span>
											<Button
												style={{
													background: "none",
													padding: 10,
													cursor: "pointer",
													color: "black",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													gap: 2,
												}}
												onClick={addNewGuideline}
											>
												Adicionar Diretriz
											</Button>
										</CardTitle>
										<CardText>
											<Table striped bordered hover>
												<thead>
													<tr>
														<th>Nome</th>
														<th>Descrição</th>
														<th>
															Exibir no dashboard
														</th>
														<th>Ações</th>
													</tr>
												</thead>
												<tbody>
													{guidelines.map(
														(guideline, index) => {
															return (
																<tr key={index}>
																	<td>
																		<Input
																			name="name"
																			placeholder="Nome"
																			type="text"
																			className="form-control"
																			id="validationCustom01"
																			onChange={(
																				event,
																			) =>
																				changeGuideline(
																					event,
																					index,
																					"name",
																				)
																			}
																			value={
																				guideline.name
																			}
																			maxLength={
																				30
																			}
																		/>
																	</td>
																	<td>
																		<Input
																			name="description"
																			placeholder="Descrição"
																			type="textarea"
																			className="form-control"
																			id="validationCustom01"
																			rows="8"
																			onChange={(
																				event,
																			) =>
																				changeGuideline(
																					event,
																					index,
																					"description",
																				)
																			}
																			value={
																				guideline.description
																			}
																		/>
																	</td>
																	<td>
																		<FormGroup
																			switch
																		>
																			<Input
																				type="switch"
																				checked={
																					guideline.show_dashboard
																				}
																				onClick={() =>
																					toggleGuidelineSwitch(
																						index,
																					)
																				}
																				name={`show_dashboard_${index}`}
																			/>
																			<Label
																				check
																			>
																				Exibir?
																			</Label>
																		</FormGroup>
																	</td>
																	<td>
																		<Button
																			style={{
																				background:
																					"none",
																				cursor: "pointer",
																				color: "black",
																				display:
																					"flex",
																				alignItems:
																					"center",
																				justifyContent:
																					"center",
																				gap: 2,
																			}}
																			onClick={() =>
																				removeGuideline(
																					index,
																				)
																			}
																		>
																			<Trash
																				size={
																					16
																				}
																			/>{" "}
																			Excluir
																		</Button>
																	</td>
																</tr>
															);
														},
													)}
												</tbody>
											</Table>
										</CardText>
									</Card>
								</Col>
							</Row>
						</TabPane>
					</TabContent>

					<div
						className="page-title-right"
						style={{ display: "flex", justifyContent: "end" }}
					>
						<Button
							type="submit"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
								width: 150,
								marginTop: 5,
							}}
						>
							{isLoading ? (
								<span
									className="spinner-border spinner-border-sm mr-1"
									style={{ marginRight: 10 }}
								></span>
							) : null}
							<FloppyDisk size={16} /> Salvar
						</Button>
					</div>
				</Form>
			</div>
			<ModalSetor show={showModal} onCloseClick={onCloseModal} />
		</div>
	);
};

FormEmpresa.propTypes = {
	preGlobalFilteredRows: PropTypes.any,
};

export default withRouter(FormEmpresa);
